import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const hiddenPages = ["/loading", "/loading-2", "/loading-3", "/loading-4", "/loading-5", "/"];

export default function CookieYesController() {
  const location = useLocation();

  useEffect(() => {
    if (typeof document === "undefined") return;
    
    if (hiddenPages.includes(location.pathname)) {
      // ПОКАЗЫВАЕМ куки на главной и prediction
      document.body.classList.remove("hide-cookie-banner");
    } else {
      // СКРЫВАЕМ куки на всех остальных страницах
      document.body.classList.add("hide-cookie-banner");
    }
  }, [location.pathname]);

  return null;
}